var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-border"},[_c('div',[_vm._t("heading",null,{"title":_vm.title})],2),_c('div',[_vm._t("content",null,{"id":_vm.id})],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }